import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { TableChart, ChartEvents, theme as defaultTheme, } from '@keen.io/charts';
import { Card } from '@keen.io/ui-core';
import { HeaderContainer } from './table-chart.widget.styles';
import WidgetHeading from '../widget-heading.component';
export var TableChartWidget = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b, title = _a.title, subtitle = _a.subtitle, card = _a.card, tags = _a.tags, eventBus = _a.eventBus, _c = _a.inEditMode, inEditMode = _c === void 0 ? false : _c, props = __rest(_a, ["theme", "title", "subtitle", "card", "tags", "eventBus", "inEditMode"]);
    var _d = __read(useState(null), 2), chartEvents = _d[0], setChartEvents = _d[1];
    useEffect(function () {
        if (inEditMode && eventBus && chartEvents === null) {
            setChartEvents(new ChartEvents({ pubsub: eventBus }));
        }
        else {
            setChartEvents(null);
        }
    }, [inEditMode]);
    return (React.createElement(Card, __assign({}, card, { padding: 0 }),
        React.createElement(React.Fragment, null,
            (title.content || subtitle.content) && (React.createElement(HeaderContainer, { padding: card.padding },
                React.createElement(WidgetHeading, { title: title, subtitle: subtitle, tags: tags }))),
            React.createElement(TableChart, __assign({}, props, { theme: theme, chartEvents: chartEvents, enableEditMode: inEditMode })))));
};
export default TableChartWidget;
